'use strict';
module.exports = function show(element) {
	if (element.style.display === 'none') {
		element.style.display = '';
	}
};
